import clsx from 'clsx'
import { useRef, useState } from 'react'
import { Checkbox } from 'react-checkbox-group'
import CheckMark from './CheckMark'
import { makeStyles } from '@mui/styles'
import { getRawMessage } from '../../../locale'
import formState from 'components/Pages/FormMaker/formState'
import { Observer } from 'mobx-react'

const useStyles = makeStyles((theme) => ({
  otherOption: {
    display: 'flex',
    alignItems: 'center',
    '& input': {
      margin: theme.spacing(0, 0.5),
    },
    '& p': {
      margin: theme.spacing(0, 1),
    },
  },
}))
export default function OtherCheckBoxInput({
  onChange,
  isChecked,
  uniqueName,
  valueList,
}) {
  const inputRef = useRef(null)
  const [inputValue, setInputValue] = useState('')
  const [savedValue, setSavedValue] = useState('')
  const classes = useStyles()

  const updateFieldValue = (value) => {
    const newList = valueList.filter(
      (selectedValue) => selectedValue !== savedValue
    )
    setSavedValue(value)
    onChange([...newList, value])
  }

  const focusInput = () => {
    inputRef.current.focus()
    setSavedValue(inputValue)
  }

  const onInputChange = (value) => {
    setInputValue(value)
    updateFieldValue(value)
  }

  const isOtherChoiceSelected = () => inputValue && isChecked(savedValue)

  return (
    <Observer>
      {() => {
        const label =
          formState
            .$('theme_config')
            .$('customized_texts')
            .$('other_choice_label').value || getRawMessage('general.other')

        return (
          <label className="formz-checkbox-label">
            <Checkbox
              value={inputValue}
              className="formz-checkbox formz-label__checkbox"
              key={`${uniqueName}-checkbox-other`}
              onClick={focusInput}
            />
            <span className="formz-label__text">
              <span className="formz-label__check">
                <div className="formz-icon">
                  <CheckMark selected={isOtherChoiceSelected} />
                </div>
              </span>
            </span>
            <div
              className={clsx({
                [classes.otherOption]: true,
              })}
            >
              <p>{label}</p>
              <input
                className="choice-other-option-input"
                value={inputValue}
                ref={inputRef}
                type="text"
                name={`${uniqueName}-checkbox-other`}
                onChange={(event) => onInputChange(event.target.value)}
              />
            </div>
          </label>
        )
      }}
    </Observer>
  )
}
